import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const providerServiceAreaApi = createApi({
  reducerPath: "providerServiceAreaApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "users/service-area",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token; 
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  endpoints: (builder)=>({ 
   getProviderServiceArea: builder.query({
    query: () => {
      
      let url = "?limit=50";

    //   if (filter) {
    //     url += `category=${filter}`;
    //   }

    //   if (sort) {
    //     url += `&sort=${sort}`;
    //   }

    //   if (search) {
    //     url += `&search=${search}`;
    //   }

     

    //   if (page) {
    //     url += `&page=${page}`;
    //   }

      return {
        url:"?limit=50",
        method: "GET",
        // body: area,
      };
    },
  }),

  createArea: builder.mutation({
      query: ({ ...body }) => {
        const payload = { ...body };

        // if (role === "customer") payload.userId = userId;
        // if (role === "provider") payload.userId = userId;
    
        return {
          url: "/",
          method: "POST",
          body: payload,
        };
      },
      // invalidatesTags: ["Address"],
    }),

    updateArea: builder.mutation({
      query: ({ id, body }) => ({
        // const payload = {}
        url: `/`,
        method: "POST",
        body,
      }),
      // invalidatesTags: ["Address"],
    }),

    getOneArea: builder.query({
      query: (query = {}) => {
        const {  limit = 50, id, } = query;
        let url = `/${id}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    deleteArea: builder.mutation({
      query: ({ userId, areaId }) => ({
        url: `/${areaId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Address"],
    }),
  })
});

export const {useGetProviderServiceAreaQuery, useCreateAreaMutation, useUpdateAreaMutation, useGetOneAreaQuery , useDeleteAreaMutation} = providerServiceAreaApi